@if (showInstall) {
    @if (variant === 'footer') {
        <button
            type="button"
            class="app-install-footer-btn"
            [matTooltip]="tooltip"
            aria-label="Install BizCare desktop app"
            (click)="install()"
        >
            <!-- <span class="app-install-footer-icon">
                <mat-icon [svgIcon]="'heroicons_outline:computer-desktop'"></mat-icon>
            </span> -->
            <span class="app-install-footer-text">
                <span class="app-install-footer-title">Install Desktop App</span>
                <span class="app-install-footer-sub">Download BizCare for your computer</span>
            </span>
            <!-- <mat-icon class="app-install-footer-arrow" [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon> -->
        </button>
    } @else if (variant === 'menu') {
        <button
            type="button"
            class="sidebar-account-action"
            [attr.aria-label]="tooltip"
            (click)="install()"
        >
            <mat-icon
                class="icon-size-5 sidebar-account-action-icon"
                [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
            <span>Install desktop app</span>
        </button>
    } @else if (variant === 'chip') {
        <button
            mat-icon-button
            type="button"
            class="app-install-chip-btn"
            matTooltip="Get Shortcut App"
            aria-label="Get Shortcut App"
            (click)="install()"
        >
            <mat-icon [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
        </button>
    } @else if (variant === 'icon') {
        <button
            mat-icon-button
            type="button"
            [matTooltip]="tooltip"
            aria-label="Install BizCare app"
            (click)="install()"
        >
            <mat-icon [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
        </button>
    } @else {
        <button
            mat-stroked-button
            type="button"
            class="app-install-text-btn"
            (click)="install()"
        >
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
            <span>Install Desktop App</span>
        </button>
    }
}
